import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { oeeContext } from '../../../core/interceptors/api-interceptor.interceptor';
import { IBaseResponse, IGetManyResponse } from '../../../utilities/http-utilities.service';
import { IOeeCurrentShift, IOeeLine, IOeeShift } from './oee-tracker.interface';

/** `StatusesEnum.ACTIVE` in OEE Tracker. */
const OEE_ACTIVE_STATUS_ID = 1;

@Injectable({ providedIn: 'root' })
export class OeeTrackerService {
  constructor(private readonly http: HttpClient) {}

  public getLines(limit = 500): Observable<IGetManyResponse<IOeeLine>> {
    const params: HttpParams = new HttpParams()
      .set('fields', 'title')
      .set('filter', `statusId||$eq||${OEE_ACTIVE_STATUS_ID}`)
      .set('limit', limit);

    return this.http.get<IGetManyResponse<IOeeLine>>('lines', { context: oeeContext, params });
  }

  public getShifts(lineIds: number[]): Observable<IBaseResponse<IOeeShift[]>> {
    const params: HttpParams = new HttpParams().set('lineIds', lineIds.join(','));

    return this.http.get<IBaseResponse<IOeeShift[]>>('scheduler/shifts/list', { context: oeeContext, params });
  }

  public getCurrentShifts(lineId: number): Observable<IBaseResponse<IOeeCurrentShift[]>> {
    const params: HttpParams = new HttpParams().set('lineIds', `[${lineId}]`);

    return this.http.get<IBaseResponse<IOeeCurrentShift[]>>('lines/current-shifts', { context: oeeContext, params });
  }
}
